import type { Order, OrderSide, QuantityMode } from "../../api";
import { formatCurrency, formatUnits, formatNumber } from "../portfolio/format";

export function sideLabel(side: OrderSide): string {
  return side.charAt(0).toUpperCase() + side.slice(1);
}

export function statusLabel(status: string): string {
  const s = status.replace(/_/g, " ");
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// Human description of the requested quantity in whatever mode it was entered.
export function quantityLabel(
  mode: QuantityMode,
  quantity: number,
  currency: string,
): string {
  switch (mode) {
    case "units":
      return `${formatUnits(quantity)} units`;
    case "amount":
      return formatCurrency(quantity, currency);
    case "percent":
      return `${formatNumber(quantity, quantity % 1 === 0 ? 0 : 2)}%`;
  }
}

// What the instrument column shows: a plain name, or "A → B" for a switch.
export function instrumentLabel(order: Order): string {
  if (order.side === "switch" && order.to_instrument_name) {
    return `${order.instrument_name} → ${order.to_instrument_name}`;
  }
  return order.instrument_name;
}

export function formatDate(s: string): string {
  return s.slice(0, 10);
}
